import { render, staticRenderFns } from "./orderForDetail.vue?vue&type=template&id=d9d3c64a&scoped=true&"
import script from "./orderForDetail.vue?vue&type=script&lang=js&"
export * from "./orderForDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderForDetail.vue?vue&type=style&index=0&id=d9d3c64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d3c64a",
  null
  
)

export default component.exports